import { render, staticRenderFns } from "./NewOwner.vue?vue&type=template&id=8a6cd766&scoped=true&"
import script from "./NewOwner.vue?vue&type=script&lang=js&"
export * from "./NewOwner.vue?vue&type=script&lang=js&"
import style0 from "./NewOwner.vue?vue&type=style&index=0&id=8a6cd766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6cd766",
  null
  
)

export default component.exports